import { useState } from "react";
import { accountService } from "../../services/enhancedCrudService";
import { toast } from "react-toastify";

const AccountChangePin = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    current_pin: "",
    new_pin: "",
    confirm_pin: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.new_pin !== formData.confirm_pin) {
      toast.error("New PIN and confirm PIN do not match");
      return;
    }

    if (formData.new_pin.length < 4) {
      toast.error("PIN must be at least 4 digits");
      return;
    }

    try {
      setLoading(true);
      await accountService.changePin({
        current_pin: formData.current_pin,
        new_pin: formData.new_pin,
      });
      toast.success("PIN changed successfully!");
      setFormData({
        current_pin: "",
        new_pin: "",
        confirm_pin: "",
      });
    } catch (error) {
      let message = "Failed to change PIN. Please try again.";
      if (error.response && error.response.data) {
        message =
          error.response.data.non_field_errors.length > 0
            ? error.response.data.non_field_errors[0]
            : message;
      }
      toast.error(message || "Failed to change PIN. Please try again.");
      console.error("Change PIN error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="col-md-6 col-lg-4">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Change PIN</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Current PIN</label>
                <input
                  type="password"
                  className="form-control"
                  name="current_pin"
                  value={formData.current_pin}
                  onChange={handleInputChange}
                  required
                  maxLength="4"
                />
              </div>
              <div className="form-group">
                <label>New PIN</label>
                <input
                  type="password"
                  className="form-control"
                  name="new_pin"
                  value={formData.new_pin}
                  onChange={handleInputChange}
                  required
                  maxLength="4"
                />
              </div>
              <div className="form-group">
                <label>Confirm New PIN</label>
                <input
                  type="password"
                  className="form-control"
                  name="confirm_pin"
                  value={formData.confirm_pin}
                  onChange={handleInputChange}
                  required
                  maxLength="4"
                />
              </div>
              <div className="form-group text-end">
                <button
                  type="submit"
                  className="btn btn-primary btn-block"
                  disabled={loading}
                >
                  {loading ? "Changing PIN..." : "Change PIN"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountChangePin;
